import React from "react";
import { Instagram, Facebook, ExternalLink } from "lucide-react";

const SocialMediaSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-sage-soft/20 to-aqua-soft/10">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-sage-dark mb-6">
          Siga-nos nas Redes Sociais
        </h2>
        <p className="text-lg text-sage-medium mb-8 max-w-2xl mx-auto">
          Mantenha-se atualizado com as nossas novidades, dicas de beleza e bem-estar, 
          e veja os resultados incríveis dos nossos tratamentos.
        </p>

        <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
          {/* Instagram */}
          <a 
            href="https://www.instagram.com/fontedejuvence/" 
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
          >
            <div className="bg-gradient-to-br from-pink-500 to-purple-600 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <Instagram className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-sage-dark mb-2">Instagram</h3>
            <p className="text-sage-medium mb-4">
              Veja as nossas transformações incríveis, dicas de beleza e bastidores do nosso trabalho diário.
            </p>
            <div className="flex items-center justify-center space-x-2 text-pink-500 group-hover:text-pink-600">
              <span className="font-semibold">@fontedejuvence</span>
              <ExternalLink className="w-4 h-4" />
            </div>
          </a>

          {/* Facebook */}
          <a 
            href="https://www.facebook.com/p/FONTE-DE-JUVENCE-100063727261156/?locale=pt_PT" 
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
          >
            <div className="bg-blue-600 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <Facebook className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-sage-dark mb-2">Facebook</h3>
            <p className="text-sage-medium mb-4">
              Participe na nossa comunidade, veja eventos especiais e receba dicas exclusivas de bem-estar.
            </p>
            <div className="flex items-center justify-center space-x-2 text-blue-600 group-hover:text-blue-700">
              <span className="font-semibold">Fonte de Juvence</span>
              <ExternalLink className="w-4 h-4" />
            </div>
          </a>
        </div>

        <div className="mt-12 bg-white rounded-2xl p-6 shadow-lg max-w-lg mx-auto">
          <h3 className="text-lg font-semibold text-sage-dark mb-2">
            🌟 Marque-nos nas suas fotos!
          </h3>
          <p className="text-sage-medium">
            Partilhe a sua experiência connosco usando <strong className="text-gold-warm">#FonteDeJuvence</strong> e 
            apareça na nossa galeria de clientes felizes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;